import {
    FETCH_CATEGORIES,
    FETCH_CATEGORIES_FAILURE,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORY,
    FETCH_CATEGORY_FAILURE,
    FETCH_CATEGORY_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    error: null,
    ids: [],
    loading: false,
    offset: 0,
    size: 0,
    total: 0,
};

export default function categories(state = initialState, action) {
    switch (action.type) {
        case FETCH_CATEGORIES:
        case FETCH_CATEGORY:
            return Object.assign({}, state, {
                error: null,
                loading: true,
            });
        case FETCH_CATEGORIES_FAILURE:
            return Object.assign({}, state, {
                data: {},
                error: action.payload.error,
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });
        case FETCH_CATEGORY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign(state.data, {
                    [action.payload.id]: action.payload,
                }),
                error: null,
                loading: false,
            });
        case FETCH_CATEGORIES_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                error: null,
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: action.payload.total,
            });
        case FETCH_CATEGORY_FAILURE:
            return Object.assign({}, state, {
                data: {},
                error: action.payload.error,
                loading: false,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/categoriesReducer.js